/* eslint-disable no-undef */
import $ from "jquery";

const productByCategoryPagination = () => {
  const init = () => {
    handlePagination();
  };

  const handlePagination = () => {
    const el = {
      button: "#js-loadmore-product-by-category",
      input: "#js-loadmore-product-by-category-input",
      slug: "#js-loadmore-product-by-category-slug",
      wrapper: "#js-products-wrapper",
    };

    if ($(el.button).length === 0) return;

    $(document).on("click", el.button, function (e) {
      e.preventDefault();

      const thisEl = $(this);

      $.ajax({
        type: "POST",
        dataType: "json",
        url: parameters.url_admin_ajax,
        data: {
          action: parameters.productByCategoryPagination.action,
          nonce: parameters.productByCategoryPagination.nonce,
          page: $(el.input).val(),
          slug: $(el.slug).val(),
        },
        beforeSend() {
          thisEl.attr("disabled", true);
        },
        success(res) {
          $(el.input).val(res.data.next_page);

          if (res.data.next_page > res.data.max_num_pages) {
            thisEl.hide();
          }

          const products = res.data.products;
          const clone = $(`${el.wrapper} > .js-clone`).clone();

          for (const i in products) {
            const copy = clone.clone();

            copy.removeAttr("style");
            copy.removeClass("js-clone");
            $("a.wrapper-img", copy).attr("href", products[i].link);
            $("a.wrapper-img > img", copy).attr("src", products[i].image[0]);
            $("a.wrapper-img > img", copy).attr("alt", products[i].name);
            $("a.wrapper-img", copy).append(products[i].tag);

            $("h2.products-wrapper__item-title", copy).html(products[i].name);
            $("span.products-wrapper__item-price", copy).html(
              products[i].price
            );
            $("a.ajax_add_to_cart", copy).attr(
              "href",
              `?add-to-cart=${products[i].id}`
            );
            $("a.ajax_add_to_cart", copy).attr(
              "data-product_id",
              products[i].id
            );
            $("a.ajax_add_to_cart", copy).attr(
              "data-product_sku",
              products[i].sku
            );
            $("a.ajax_add_to_cart", copy).attr(
              "aria-label",
              `Add ${products[i].sku} to your cart`
            );

            copy.appendTo($(el.wrapper));
          }
        },
        complete() {
          thisEl.removeAttr("disabled");
        },
      });
    });
  };
  init();
};

try {
  productByCategoryPagination();
} catch (error) {
  console.error("product-by-category-pagination.js: ", error);
}
